import TaxBracketTable from "./TaxBracketTable";
import TaxCalculatorDetail from "./TaxCalculatorDetail";

function TaxCalculator() {
  return (
    <div >
      {/* <TaxCalculatorDetail /> */}
      <TaxBracketTable />
      
    </div>
  );
}
export default TaxCalculator;
